import { Link } from 'react-router-dom'
import { Collapsible, CollapsibleItem, Dropdown, Icon } from 'react-materialize'
import { useFlags } from 'launchdarkly-react-client-sdk'
import {
  NavLink,
  Username,
  Options,
  StyledDropdown,
  StyledCollapsible,
  InactiveLink,
} from './Elements'
import CasNav from './CasNav'
import UmcNav from './UmcNav'
import { AuthPermissions } from '../../../Utilities/enum'

type UmcCasOptionsNavProps = {
  isMobile: boolean
  onNavLinkClick: () => void
  permissions: string[]
}

const UmcCasOptionsNav: React.FC<UmcCasOptionsNavProps> = ({
  isMobile,
  onNavLinkClick,
  permissions,
}) => {
  const {
    casSection,
    cmsSection,
    umcCustomReports,
    umcW8W9Reports,
    automaticTinMatching,
  } = useFlags()

  const shouldShowTransactions = permissions.includes(
    AuthPermissions.reconciliationRead
  )
  const shouldShowCasReports = permissions.includes(AuthPermissions.reportsRead)

  const shouldShowCasSection =
    casSection && (shouldShowCasReports || shouldShowTransactions)
  const shouldShowUmcSection =
    cmsSection && permissions.includes(AuthPermissions.customerRead)
  const shouldShowCustoUmcReports =
    (umcW8W9Reports || umcCustomReports || automaticTinMatching) &&
    permissions.includes(AuthPermissions.customerPiiRead)

  if (shouldShowUmcSection && shouldShowCasSection) {
    if (isMobile)
      return (
        <StyledCollapsible>
          <Collapsible accordion={true}>
            <CollapsibleItem expanded={false} header="CAS" node="div">
              <CasNav
                shouldShowTransactions={shouldShowTransactions}
                shouldShowReports={shouldShowCasReports}
                onNavLinkClick={onNavLinkClick}
                LinkComponent={Link}
              />
            </CollapsibleItem>
            <CollapsibleItem expanded={false} header="UMC" node="div">
              <UmcNav
                onNavLinkClick={onNavLinkClick}
                LinkComponent={Link}
                InactiveLinkComponent={InactiveLink}
                shouldShowReports={shouldShowCustoUmcReports}
              />
            </CollapsibleItem>
          </Collapsible>
        </StyledCollapsible>
      )
    return (
      <>
        <StyledDropdown>
          <Dropdown
            id="CASdropdown"
            options={{
              alignment: 'left',
              constrainWidth: false,
              coverTrigger: false,
              outDuration: 150,
            }}
            trigger={
              <Username>
                CAS<Icon>arrow_drop_down</Icon>
              </Username>
            }
          >
            <CasNav
              shouldShowReports={shouldShowCasReports}
              shouldShowTransactions={shouldShowTransactions}
              onNavLinkClick={onNavLinkClick}
              LinkComponent={Link}
            />
          </Dropdown>
        </StyledDropdown>
        <StyledDropdown>
          <Dropdown
            id="UMCDropdown"
            options={{
              alignment: 'left',
              constrainWidth: false,
              coverTrigger: false,
              outDuration: 150,
            }}
            trigger={
              <Options>
                UMC<Icon>arrow_drop_down</Icon>
              </Options>
            }
          >
            <UmcNav
              onNavLinkClick={onNavLinkClick}
              LinkComponent={Link}
              InactiveLinkComponent={InactiveLink}
              shouldShowReports={shouldShowCustoUmcReports}
            />
          </Dropdown>
        </StyledDropdown>
      </>
    )
  }
  if (shouldShowCasSection)
    return (
      <CasNav
        shouldShowTransactions={shouldShowTransactions}
        shouldShowReports={shouldShowCasReports}
        onNavLinkClick={onNavLinkClick}
        LinkComponent={NavLink}
      />
    )
  if (shouldShowUmcSection)
    return (
      <UmcNav
        onNavLinkClick={onNavLinkClick}
        LinkComponent={NavLink}
        InactiveLinkComponent={NavLink}
        shouldShowReports={shouldShowCustoUmcReports}
      />
    )
  return null
}

export default UmcCasOptionsNav
